import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

export class MediaGallery extends Component {
  constructor() {
    super();
    this.controller = new AbortController();

    this.handleVariantUpdate = this.handleVariantUpdate.bind(this);
    this.handleZoomMediaSelected = this.handleZoomMediaSelected.bind(this);
  }

  connectedCallback() {
    super.connectedCallback();

    const { signal } = this.controller;
    const target = this.closest('.shopify-section, dialog');

    target?.addEventListener(ThemeEvents.variantUpdate, this.handleVariantUpdate, { signal });
    this.refs?.zoomDialogComponent?.addEventListener(
      ThemeEvents.zoomMediaSelected,
      this.handleZoomMediaSelected,
      { signal }
    );
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.controller.abort();
  }

  handleVariantUpdate(event) {
    const variant =
      event.detail?.variant ||
      event.detail?.resource ||
      event.detail?.selectedVariant ||
      event.detail?.currentVariant ||
      null;

    const variantMediaId =
      variant?.featured_media?.id ||
      variant?.featured_image?.id ||
      variant?.image?.id ||
      variant?.media?.[0]?.id ||
      null;

    if (!variantMediaId) return;

    const changed = this.selectMediaById(variantMediaId, { animate: false });

    if (!changed) {
      const slides = this.getSlideshowItems();

      const index = slides.findIndex(
        (item) => String(item.dataset.mediaId) === String(variantMediaId)
      );

      if (index !== -1 && this.slideshow?.select) {
        this.slideshow.select(index, undefined, { animate: false });
      }
    }
  }

  getSlideshowItems() {
    if (!this.slideshow) return [];

    return [...this.slideshow.querySelectorAll('slideshow-slide[data-media-id]')];
  }

  selectMediaById(mediaId, options = {}) {
    if (!mediaId) return false;

    const { animate = false } = options;

    const slideshowItems = this.getSlideshowItems();
    const gridItems = [
      ...this.querySelectorAll('.media-gallery__grid [ref="media[]"][data-media-id]'),
    ];

    const mediaItems = slideshowItems.length ? slideshowItems : gridItems;

    if (!mediaItems.length) return false;

    const index = mediaItems.findIndex(
      (item) => String(item.dataset.mediaId) === String(mediaId)
    );

    if (index === -1) return false;

    if (this.presentation === 'carousel' && this.slideshow?.select) {
      this.slideshow.select(index, undefined, { animate });
      return true;
    }

    mediaItems[index]?.scrollIntoView({
      behavior: animate ? 'smooth' : 'auto',
      block: 'nearest',
      inline: 'nearest',
    });

    return true;
  }

  handleZoomMediaSelected(event) {
    this.slideshow?.select(event.detail.index, undefined, { animate: false });
  }

  zoom(index, event) {
    this.refs?.zoomDialogComponent?.open(index, event);
  }

  get slideshow() {
    return this.refs?.slideshow;
  }

  get media() {
    return this.refs?.media;
  }

  get presentation() {
    return this.dataset.presentation;
  }
}

if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', MediaGallery);
}